import { render, staticRenderFns } from "./ExtendOtherNutrientsVitaminB6.vue?vue&type=template&id=46a2c448&scoped=true"
import script from "./ExtendOtherNutrientsVitaminB6.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsVitaminB6.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsVitaminB6.vue?vue&type=style&index=0&id=46a2c448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a2c448",
  null
  
)

export default component.exports